<template>
    <div
      class="draggable-button"
      :style="{ top: buttonPosition.top + 'vh', left: buttonPosition.left + 'vw' }"
      @mousedown="startDrag"
      @touchstart="startDrag"
    >
      <button @click="handleClick" class="mobile-button">
        <i :class="iconClass"></i>
      </button>
    </div>
  </template>

<script>
export default {
  name: 'DraggableButton',
  props: {
    onClick: {
      type: Function,
      default: () => {}
    },
    expanded: {
      type: Boolean,
      default: false
    },
    iconClass: {
      type: String,
      default: null
    },
    buttonPosition: {
      type: Object,
      default: () => ({
        top: 5,
        left: 2
      }),
      validator: value => {
        return typeof value.top === 'number' && typeof value.left === 'number'
      }
    },
    draggable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isDragging: false,
      startX: 0,
      startY: 0,
      startTop: 0,
      startLeft: 0,
      buttonWidth: 56, // Largura do botão
      buttonHeight: 56, // Altura do botão
      marginTop: 16, // Margem superior
      marginLeftRight: 16 // Margem esquerda e direita
    }
  },
  methods: {
    startDrag (event) {
      if (!this.draggable) return // Verifica se o botão é arrastável

      this.isDragging = true
      this.startX = event.clientX || event.touches[0].clientX
      this.startY = event.clientY || event.touches[0].clientY
      this.startTop = this.buttonPosition.top
      this.startLeft = this.buttonPosition.left

      // Adicionar event listeners para arrasto
      document.addEventListener('mousemove', this.drag)
      document.addEventListener('touchmove', this.drag, { passive: false })
      document.addEventListener('mouseup', this.stopDrag)
      document.addEventListener('touchend', this.stopDrag)
    },
    drag (event) {
      if (!this.isDragging || !this.draggable) return // Verifica se o botão é arrastável

      const x = event.clientX || event.touches[0].clientX
      const y = event.clientY || event.touches[0].clientY

      let newTop = this.startTop + (y - this.startY)
      let newLeft = this.startLeft + (x - this.startX)

      // Limitar o botão dentro da tela
      const maxTop = window.innerHeight - this.buttonHeight - this.marginTop
      const maxLeft = window.innerWidth - this.buttonWidth - this.marginLeftRight

      newTop = Math.max(this.marginTop, Math.min(newTop, maxTop))
      newLeft = Math.max(this.marginLeftRight, Math.min(newLeft, maxLeft))

      this.$emit('update:buttonPosition', { top: newTop, left: newLeft })

      event.preventDefault()
    },
    stopDrag () {
      if (!this.draggable) return // Verifica se o botão é arrastável

      this.isDragging = false

      // Remover event listeners após o arrasto
      document.removeEventListener('mousemove', this.drag)
      document.removeEventListener('touchmove', this.drag)
      document.removeEventListener('mouseup', this.stopDrag)
      document.removeEventListener('touchend', this.stopDrag)
    },
    handleClick () {
      if (this.onClick) {
        this.onClick()
      }
    }
  }
}
</script>

  <style scoped>
  .draggable-button {
    position: fixed;
    z-index: 1000; /* Garantir que o botão esteja acima de outros elementos */
    cursor: move; /* Indicar que o botão é arrastável */
  }

  .mobile-button {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0BACA0;
    color: white;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    font-size: 24px;
    border: none;
    pointer-events: auto; /* Garantir que o botão possa receber eventos de ponteiro */
  }

  .mobile-button:hover {
    background-color: #089F8C;
    cursor: pointer;
  }

  .mobile-button .fa {
    margin: 0;
  }
  </style>



// WEBPACK FOOTER //
// src/components/nexum/components/buttons/NxDraggableButton.vue